import { defineComponent, computed } from 'vue';
import { KeyGetter, toArray, getKey } from '@/packages/selection-controller/general/main';
import { ItemValue, isUndefined, isArray, makeOptions, ItemsMap } from '@/packages/selection-controller/general/main'
import {
  updateValue, defaultNextResolver,
} from '@/packages/selection-controller/ordering/main';

export default defineComponent({
  name: 'vue-ordering-controller',

  props: {
    multiple: { type: Boolean, default: false },
    value: {},
    directionNextGetter: { type: Function, default: defaultNextResolver },
    directionGetter: { type: Function, default: (item) => item?.value || null },
    keyGetter: { type: Function, default: (item) => item?.key || item },
    updator: { type: Function, default: updateValue },
  },
  emits: ['input'],
  setup(props, { emit, slots}) {

    const valueMap = computed(() => {
      return new ItemsMap(props.value ? props.value as unknown as any : [])
    })


    function change(change) {
      console.log('props.value', valueMap.value, change);
      const value = props.updator(
        props.directionNextGetter, props.multiple, valueMap.value, change
      );
      console.log('value', value, typeof value.items, typeof []);
      emit('input', [...value.items]);
    }

    return () => slots.default({
      value: props.value,
      valueMap: valueMap.value,
      multiple: props.multiple,
      change,
      directionNextGetter: props.directionNextGetter,
      directionGetter: props.directionGetter,
    })
  }
})
